import http from './http';
import config from '~/config';
import { stringUtils, auth as authUtils } from '~/util';

export const registerUser = async (payload) => {
    const url =  `${config.urls.security}/registration`; 

    let _payload = { ...payload };

    if (!stringUtils.hasValue(payload?.password)) {
        _payload.password = authUtils.generateTempPassword();
        console.log('generated PW', _payload.password);
    }

    return http.post(
        url,
        _payload,
        {
            authHeader: false
        });
};

export const getUserDetails = async (userId) => {
    const url =  `${config.urls.security}/user/${userId}`; 
    return http.get(url);
};

export const updateUserDetails = async (userId, payload) => {
    const url =  `${config.urls.security}/user/${userId}`; 
    return http.patch(url, payload);
};

export const updateUserPreferences = async (userId, payload) => {
    const url =  `${config.urls.security}/user/${userId}/preferences`; 
    return http.patch(url, payload);
};

export const getAllUsers = async () => {
    const url =  `${config.urls.security}/user`; 
    return http.get(url);
};

/**
 * Returns true if the given username is already taken
 * @param {string} username The username to check
 * @returns {boolean}
 */
export const isUsernameTaken = async (username) => {
    const url = `${config.urls.security}/username`;
    const response = await http.get2(url, { username });
    
    if (response.errored) {
        throw Error(`Error response from ${url} - ${response.error}`);
    }

    return response[`${username}`];
};

export const deleteUser = async (userId) => {
    const url =  `${config.urls.security}/user/delete/${userId}`; 
    return http.patch(url);
};

export default {
    registerUser,
    getUserDetails,
    updateUserDetails,
    updateUserPreferences,
    getAllUsers,
    isUsernameTaken,
    deleteUser
};